export const drawer = {
	create: {
		title: "Add product",
		notifications: {
			success: "Product created successfully!",
			genericError: "Error creating product",
		},
		unsavedChanges: {
			title: "Exit creation",
			message:
				"Are you sure you want to exit the creation of this product? " +
				"You will lose the information filled in so far.",
			cancel: "Cancel",
			confirm: "Exit creation",
		},
	},
	edit: {
		title: "Edit product",
		notifications: {
			success: "Product updated successfully!",
			genericError: "Error updating product",
			barUpdateError: "Failed to update some bar associations.",
			barOperationsFailed: "{{ errorCount }} out of {{ total }} bar operations failed.",
		},
		unsavedChanges: {
			title: "Exit editing",
			message:
				"Are you sure you want to exit editing this product? " +
				"You will lose the information filled in so far.",
			cancel: "Cancel",
			confirm: "Exit editing",
		},
	},
	linkToBars: {
		title: "Link your product to bars",
		message:
			"Product registered successfully! Now just link it to the bars to start selling",
		searchBars: "Search bars",
		selectPlaceholder: "Search available bars to link",
		suggestionText: "Bar suggestions",
		skip: "Skip",
		linkProduct: "Finish",
		finishWithoutLinking: "Finish without linking",
		stock: "Stock",
		internalIp: "Internal IP",
		notifications: {
			success: "Product linked to bar(s) successfully!",
			finishedWithoutLinking: "Product registered successfully!",
			error: "Failed to link product to {{ errorCount }} bar(s).",
			genericError: "Error linking product to bar(s).",
			allFailed: "Failed to link product to all {{ total }} selected bars: {{ bars }}",
			partialSuccess:
				"Product linked to {{ successCount }} of {{ total }} bars. " +
				"{{ errorCount }} failed: {{ failedBars }}",
		},
		success: {
			title: "Product registered successfully!",
			message:
				"Your product is now active in bars and you can configure them in the bars as well.",
			understand: "Got it",
		},
	},
};
